// Groups a definition's fields for the one-scroll in-app fill: a section
// field starts a group that holds every field after it until the next
// section. Fields before the first section form a leading group with
// `section: null`. Empty leading groups are dropped; an empty section is
// kept so its title still shows.
export const groupSections = (fields) => {
  const groups = [];
  let current = { key: 'start', section: null, items: [] };
  (fields || []).forEach((field) => {
    if (!field) return;
    if (field.type === 'section') {
      if (current.section || current.items.length) groups.push(current);
      current = { key: field.id, section: field, items: [] };
      return;
    }
    current.items.push(field);
  });
  if (current.section || current.items.length) groups.push(current);
  return groups;
};

export default groupSections;
